import { gql } from '@apollo/client';

export const BulkTicketingDataFileUploadFragment = gql`
  fragment BulkTicketingDataFileUpload on BulkTicketingDataFileUpload {
    id
    createdAt
    fileName
    signedUrl
    ticketingProvider
    ticketingEntityType
    isValid
  }
`;
